import { render, staticRenderFns } from "./customerFilter.vue?vue&type=template&id=64355a90&scoped=true&"
import script from "./customerFilter.vue?vue&type=script&lang=js&"
export * from "./customerFilter.vue?vue&type=script&lang=js&"
import style0 from "./customerFilter.vue?vue&type=style&index=0&id=64355a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64355a90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64355a90')) {
      api.createRecord('64355a90', component.options)
    } else {
      api.reload('64355a90', component.options)
    }
    module.hot.accept("./customerFilter.vue?vue&type=template&id=64355a90&scoped=true&", function () {
      api.rerender('64355a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/customerFilter.vue"
export default component.exports